module.exports = __webpack_public_path__ + "img/tweed_10_20_b.f24a4cf7.jpg";